module.exports = __webpack_public_path__ + "img/业主决策.683049a2.png";